
import axios from 'axios';
// Customer API for regular clients
export const customerAPI = {
  getCustomers: () => api.get('/customers'),
  addCustomer: (data) => api.post('/customers', data),
  deleteCustomer: (id) => api.delete(`/customers/${id}`),
};

const USER_APP_TOKEN_KEY = 'userAppToken';

const resolveApiBaseUrl = () => {
  const configuredUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

  try {
    const parsedUrl = new URL(configuredUrl);
    const isLocalHost = parsedUrl.hostname === 'localhost' || parsedUrl.hostname === '127.0.0.1';
    const runtimeHost = typeof window !== 'undefined' ? window.location.hostname : '';
    const runtimeIsRemote = runtimeHost && runtimeHost !== 'localhost' && runtimeHost !== '127.0.0.1';

    if (isLocalHost && runtimeIsRemote) {
      parsedUrl.hostname = runtimeHost;
      return parsedUrl.toString().replace(/\/$/, '');
    }

    return configuredUrl.replace(/\/$/, '');
  } catch (error) {
    return configuredUrl.replace(/\/$/, '');
  }
};

const API_BASE_URL = resolveApiBaseUrl();

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(USER_APP_TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const userAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  getUserById: (id) => api.get(`/users/${id}`),
  getServicesByUser: (userId) => api.get(`/appointments/services/${userId}`),
  getMonthlyReport: (month, year) => api.get(`/users/monthly-report?month=${month}&year=${year}`),
  refreshCurrentUser: () => api.get('/auth/me'),
  changePassword: (current_password, new_password) =>
    api.put('/auth/change-password', { current_password, new_password }),
  reportIssue: (message) => api.post('/issues', { message }),
  updateDisplayName: (userId, displayName) =>
  api.patch(`/users/${userId}/display-name`, { display_name: displayName }),
};

export const serviceAPI = {
  getServices: (userId) => api.get(`/appointments/services/manage/${userId}`),
  createService: (data) => api.post('/appointments/services', data),
  deleteService: (id) => api.delete(`/appointments/services/${id}`),
  updateService: (id, data) => api.put(`/appointments/services/${id}`, data),
};

export const appointmentAPI = {
  getUserAppointments: () => api.get('/appointments/my-appointments'),
  getAppointmentsByUser: () => api.get('/appointments/my-appointments'),
  confirmAppointment: (id) => api.put(`/appointments/${id}/status`, { status: 'confirmed' }),
  declineAppointment: (id) => api.put(`/appointments/${id}/status`, { status: 'declined' }),
  updateAppointmentPrice: (id, price) => api.put(`/appointments/${id}/price`, { price }),
  cancelAppointment: (id) => api.put(`/appointments/${id}/cancel`),
  rescheduleAppointment: (id, appointment_date) => api.put(`/appointments/${id}/reschedule`, { appointment_date }),
  getAvailableSlots: (userId, date, duration, excludeAppointmentId) => {
    const params = `userId=${userId}&date=${date}${duration ? `&duration=${duration}` : ''}${excludeAppointmentId ? `&excludeId=${excludeAppointmentId}` : ''}`;
    return api.get(`/appointments/available-slots?${params}`);
  },
  bookAppointment: (data) => api.post('/appointments/book', data),
  bookManual: (data) => api.post('/appointments/book', data),
};

export const authAPI = {
  login: (data) => api.post('/auth/login', data),
};

export const workHoursAPI = {
  getWorkHours: (userId) => api.get(`/work-hours/${userId}`),
  setWorkHours: (userId, workHours) => api.post(`/work-hours/${userId}`, { workHours }),
};

export default api;
